export default "__VITE_ASSET__C$2PaI4O__"